import React, { useState } from "react";
import "../../../styles/pause-system/pause-view.css";
import {
  convertStraight,
  convertThenFormat,
  convertTo12HourFormat,
  formatDateTimezon,
} from "../../common-data/Converts";

const ViewDetails = ({ rowData }) => {
  const [activeTab, setActiveTab] = useState("regular");

  return (
    <div className="user-profile-container staff-onboarding-detail-modal pause-view-details">
      <div className="pause-details-two-col">
        {/* Left: Member Info */}
        <div className="member-info-card">
          <div className="member-info-header">
            <span className="mi-icon">👤</span>
            <span className="mi-title">Member Info</span>
          </div>
          <div className="member-info-body">
            <div className="mi-row">
              <span className="mi-label">Name</span>
              <span className="mi-value">{rowData?.name || "NA"}</span>
            </div>
            <div className="mi-row">
              <span className="mi-label">Mobile</span>
              <span className="mi-value">{rowData?.mobile || "NA"}</span>
            </div>
            <div className="mi-row">
              <span className="mi-label">Email</span>
              <span className="mi-value">{rowData?.email || "NA"}</span>
            </div>
            <div className="mi-row">
              <span className="mi-label">Gender</span>
              <span className="mi-value">{rowData?.gender || "NA"}</span>
            </div>
            <div className="mi-row">
              <span className="mi-label">Gym Name</span>
              <span className="mi-value">{rowData?.gym_name || "NA"}</span>
            </div>
          </div>

          {/* Tabs */}
          <div className="plan-tabs">
            <button
              className={`plan-tab-btn ${
                activeTab === "regular" ? "active" : ""
              }`}
              onClick={() => setActiveTab("regular")}
              disabled={!rowData.regular || rowData.regular.length === 0}>
              Regular Plan
            </button>
            <button
              className={`plan-tab-btn ${activeTab === "pt" ? "active" : ""}`}
              onClick={() => setActiveTab("pt")}
              disabled={!rowData.addon_pt || rowData.addon_pt.length === 0}>
              PT Plan
            </button>
          </div>

          {/* Tab Content */}
          {activeTab === "regular" &&
            rowData.regular &&
            rowData.regular.length > 0 && (
              <div className="plan-section">
                <div className="plan-body">
                  <div className="plan-row span2">
                    <span>Plan Name</span>
                    <span>{rowData.regular[0].plan_name || "NA"}</span>
                  </div>

                  <div className="plan-row">
                    <span>Duration</span>
                    <span>{rowData.regular[0].plan_duration || "NA"}</span>
                  </div>

                  <div className="plan-row">
                    <span>Price</span>
                    <span>
                      ₹{convertThenFormat(rowData.regular[0].plan_price || 0)}
                    </span>
                  </div>

                  <div className="plan-row">
                    <span>Start Date</span>
                    <span>
                      {rowData.regular[0].start_date
                        ? convertStraight(rowData.regular[0].start_date)
                        : "NA"}
                    </span>
                  </div>

                  <div className="plan-row">
                    <span>Expire Date</span>
                    <span>
                      {rowData.regular[0].expire_date
                        ? convertStraight(rowData.regular[0].expire_date)
                        : "NA"}
                    </span>
                  </div>

                  <div className="plan-row">
                    <span>Status</span>
                    <span
                      className={`status-badge ${
                        rowData.regular[0].regular_plan_status === "active"
                          ? "status-active"
                          : "status-inactive"
                      }`}>
                      {rowData.regular[0].regular_plan_status || "NA"}
                    </span>
                  </div>
                </div>
              </div>
            )}

          {activeTab === "pt" &&
            rowData.addon_pt &&
            rowData.addon_pt.length > 0 && (
              <div className="plan-section">
                <div className="plan-body">
                  <div className="plan-row span2">
                    <span>Trainer</span>
                    <span>{rowData.addon_pt[0].trainer_name || "NA"}</span>
                  </div>

                  <div className="plan-row">
                    <span>Sessions</span>
                    <span>{rowData.addon_pt[0].n_session || "NA"}</span>
                  </div>

                  <div className="plan-row">
                    <span>Session Duration</span>
                    <span>
                      {rowData.addon_pt[0].session_duration || "NA"} min
                    </span>
                  </div>

                  <div className="plan-row span2">
                    <span>Slot</span>
                    <span>
                      {rowData.addon_pt[0].start_time &&
                      rowData.addon_pt[0].end_time
                        ? `${
                            rowData.addon_pt[0].start_time
                              ? convertTo12HourFormat(
                                  rowData.addon_pt[0].start_time
                                )
                              : ""
                          } - ${
                            rowData.addon_pt[0].end_time
                              ? convertTo12HourFormat(
                                  rowData.addon_pt[0].end_time
                                )
                              : ""
                          }`
                        : "NA"}
                    </span>
                  </div>

                  <div className="plan-row">
                    <span>Status</span>
                    <span
                      className={`status-badge ${
                        rowData.addon_pt[0].pt_plan_status === "active"
                          ? "status-active"
                          : "status-inactive"
                      }`}>
                      {rowData.addon_pt[0].pt_plan_status || "NA"}
                    </span>
                  </div>
                </div>
              </div>
            )}
        </div>

        {/* Right: Pause History */}
        <div className="pause-history-card">
          <div className="pause-history-header">
            <span className="ph-icon">⏸️</span>
            <span className="ph-title">Pause History</span>
          </div>
          <div className="pause-history-body">
            <div className="ph-grid">
              <div className="ph-row">
                <span className="ph-label">Pause No</span>
                <span className="ph-value">{rowData?.pause_no ?? "NA"}</span>
              </div>

              <div className="ph-row">
                <span className="ph-label">Pause Status</span>
                <span
                  className={`status-badge ${
                    rowData?.pause_status === "true"
                      ? "status-active"
                      : "status-inactive"
                  }`}>
                  {rowData?.pause_status === "true" ? "Active" : "Inactive"}
                </span>
              </div>

              <div className="ph-row">
                <span className="ph-label">Total Pause</span>
                <span className="ph-value">{rowData?.total_pause ?? "NA"}</span>
              </div>

              <div className="ph-row">
                <span className="ph-label">Remaining Pause</span>
                <span className="ph-value">
                  {rowData?.remaining_pause ?? "NA"}
                </span>
              </div>

              <div className="ph-row">
                <span className="ph-label">Total Pause Days</span>
                <span className="ph-value">
                  {rowData?.total_pause_days ?? "NA"}
                </span>
              </div>

              <div className="ph-row">
                <span className="ph-label">Remaining Pause Days</span>
                <span className="ph-value">
                  {rowData?.remaining_pausedays ?? "NA"}
                </span>
              </div>

              <div className="ph-row">
                <span className="ph-label">Total Pause Limit Used</span>
                <span className="ph-value">
                  {rowData?.total_pause_initiated ?? "NA"}
                </span>
              </div>

              <div className="ph-row">
                <span className="ph-label">Date Added</span>
                <span className="ph-value">
                  {rowData?.date_added
                    ? formatDateTimezon(rowData?.date_added)
                    : "NA"}
                </span>
              </div>

              <div className="ph-row span2">
                <span className="ph-label">Added By</span>
                <span className="ph-value">{rowData?.admin_name || "NA"}</span>
              </div>

              <div className="ph-row span3">
                <span className="ph-label">Reason</span>
                <span className="ph-value ph-remark">
                  {rowData?.remark || "NA"}
                </span>
              </div>
            </div>

            {/* Two cards in one row for Regular and PT Pause Info */}
            <div className="pause-plan-row">
              {rowData.regular && rowData.regular.length > 0 && (
                <div className="pause-plan-box">
                  <div className="pause-plan-title regular">
                    Regular Plan Pause
                  </div>

                  <div className="ph-row">
                    <span className="ph-label">Pause Start Date</span>
                    <span className="ph-value">
                      {rowData.regular[0].pause_start_date
                        ? convertStraight(rowData.regular[0].pause_start_date)
                        : "NA"}
                    </span>
                  </div>

                  <div className="ph-row">
                    <span className="ph-label">Pause End Date</span>
                    <span className="ph-value">
                      {rowData.regular[0].pause_end_date
                        ? convertStraight(rowData.regular[0].pause_end_date)
                        : "NA"}
                    </span>
                  </div>
                </div>
              )}

              {rowData.addon_pt && rowData.addon_pt.length > 0 && (
                <div className="pause-plan-box">
                  <div className="pause-plan-title pt">PT Plan Pause</div>

                  <div className="ph-row">
                    <span className="ph-label">Pause Start Date</span>
                    <span className="ph-value">
                      {rowData.addon_pt[0].pause_start_date
                        ? convertStraight(rowData.addon_pt[0].pause_start_date)
                        : "NA"}
                    </span>
                  </div>

                  <div className="ph-row">
                    <span className="ph-label">Pause End Date</span>
                    <span className="ph-value">
                      {rowData.addon_pt[0].pause_end_date
                        ? convertStraight(rowData.addon_pt[0].pause_end_date)
                        : "NA"}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDetails;
